<script setup>
import {ref, onMounted} from "vue"

onMounted(()=>{
  loading.value = false
})

const props = defineProps({
  type: {
    type: String,
    default: 'info'
  },
  label: {
    type: String,
    default: ""
  }
})
const loading = ref(true)
</script>

<template>
  <transition name="el-zoom-in-center">
    <div class="yt_tag yt_tag_primary" v-if="props.type === 'primary' && !loading">{{props.label}}</div>
    <div class="yt_tag yt_tag_info" v-else-if="props.type === 'info' && !loading">{{props.label}}</div>
  </transition>
</template>

<style lang="scss" scoped>
.yt_tag {
  display: inline-block;
  min-width: 40px;
  min-height: 24px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 13px;
  box-sizing: border-box;
  padding: 0 12px;
  line-height: 24px;
  white-space: nowrap;
}
.yt_tag_primary {
  background: #F1EBFF;
  border: 1px solid #DECEFF;
  color: #B292F1;
}
.yt_tag_info {
  background: #ECECF4;
  color: #77788E;
}
</style>
